import { Link } from 'react-router-dom';

const features = [
  {
    icon: 'ri-book-open-line',
    title: '剧情速览',
    desc: '每部作品提供完整剧情简介与基本信息，快速了解故事脉络。',
  },
  {
    icon: 'ri-user-star-line',
    title: '角色分析',
    desc: '深度解析核心角色的成长轨迹与人物关系，读懂故事的灵魂。',
  },
  {
    icon: 'ri-newspaper-line',
    title: '资讯追踪',
    desc: '行业动态、明星资讯与剧透解析，紧跟影视圈最新热点。',
  },
  {
    icon: 'ri-filter-3-line',
    title: '多维筛选',
    desc: '按体裁、地区、年份与热度排序，高效找到你想看的内容。',
  },
];

const stats = [
  { value: '62+', label: '影视作品' },
  { value: '10+', label: '资讯更新' },
  { value: '5', label: '角色专题' },
  { value: '全终端', label: '响应式浏览' },
];

export default function SiteIntro() {
  return (
    <section className="px-4 py-12 md:px-8 md:py-16 lg:px-12">
      <div className="grid grid-cols-1 gap-10 lg:grid-cols-2 lg:items-center">
        <div>
          <span className="flex items-center gap-2 text-xs font-medium uppercase tracking-[0.18em] text-primary-600">
            <span className="h-px w-5 bg-primary-400"></span>
            About the site
          </span>
          <h2 className="mt-3 font-heading text-2xl font-semibold leading-snug text-foreground-950 md:text-3xl">
            一个专注影视剧情与角色解读的内容平台
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
            善良的女秘书网站提供详尽的影视剧剧情介绍、角色分析及相关新闻更新，涵盖电视剧和电影等多种影视内容，帮助用户了解剧情发展与角色背景。我们希望通过清晰的信息组织与友好的浏览体验，让每一次追剧都更从容。
          </p>
          <div className="mt-6 grid grid-cols-2 gap-4 sm:grid-cols-4">
            {stats.map((stat) => (
              <div
                key={stat.label}
                className="rounded-lg border border-background-200 bg-background-50 px-4 py-3"
              >
                <p className="font-heading text-xl font-bold text-primary-600">
                  {stat.value}
                </p>
                <p className="mt-0.5 text-xs text-foreground-500">{stat.label}</p>
              </div>
            ))}
          </div>
          <Link
            to="/about"
            className="mt-7 inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            了解我们
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="rounded-lg border border-background-200 bg-background-50 p-5"
            >
              <span className="flex h-11 w-11 items-center justify-center rounded-md bg-accent-100 text-accent-700">
                <i className={`${feature.icon} text-xl`}></i>
              </span>
              <h3 className="mt-4 font-heading text-base font-semibold text-foreground-950">
                {feature.title}
              </h3>
              <p className="mt-1.5 text-sm leading-relaxed text-foreground-500">
                {feature.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}